import React from "react";

// Chakra imports
import { Flex, useColorModeValue } from "@chakra-ui/react";

// Custom components
import HorizonLogo from "assets/img/Sculpt-logo.png";
import { HSeparator } from "components/separator/Separator";

export function SidebarBrand() {
  //   Chakra color mode
  let logoColor = useColorModeValue("navy.700", "white");

  return (
    <Flex align='center' direction='column'>
      <img src={HorizonLogo} className="w-[130px] my-[20px]"/>
      <HSeparator mb='20px' />
    </Flex>
  );
}

export default SidebarBrand;
